/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
				/**
				 *  $( function() { is shorthand for $( document ).ready(), this seems to work better
				 *  than the '$( document ).on( "gform_post_render", function() {' conditional
				 */
				$( function() {
					$( '.ginput_container:not(.ginput_container_fileupload) > input[type!="hidden"], .ginput_container > select' ).each( function() {
						if( $( this ).val() !== "" ) {
							$( this ).closest( ".gfield:not(.gfield_multi_time)" ).addClass( "has-focus-or-value" );
						}
					} );
				} );

				$( ".gform_wrapper" )
					.on( "focus", '.ginput_container:not(.ginput_container_fileupload) > input[type!="hidden"], .ginput_container > select', function() {
						$( this ).closest( ".gfield:not(.gfield_multi_time)" ).addClass( "has-focus-or-value" );
					} )

					.on( "blur", '.ginput_container:not(.ginput_container_fileupload) > input[type!="hidden"], .ginput_container > select', function() {
						
						// if an text or tel input is empty
						if( $( this ).val() === "" || $( this ).val() === "(___) ___-____" ) {
							$( this ).closest( ".gfield:not(.gfield_multi_time)" ).removeClass( "has-focus-or-value" );
						}
					}
				);
		
				function locationAjax( lat, lng ) {
					var subsite = $( "#subsite" ).val();

					jQuery.ajax( {
						url: subsite + '/wp-admin/admin-ajax.php',
						type: 'POST',
						data: {
							action: 'get_nearest_locations',
							lat: lat,
							lng: lng,
						},

						beforeSend: function() {
							$( '.pp-location-list' ).empty(); // remove any locations							
							$( '.loader-container' ).show(); 	// display the loader
							$( '.location-instruction' ).html( 'Daycares nearby' ); // Insert header
						},

						// response contains all the HTML
						success: function( response ) {
							$( '.loader-container' ).hide(); // hide the loader
							$( '.location-instruction' ).show(); // show the header
							$( response ).appendTo( '.pp-location-list' ); // append the locations
							
						},

						error: function( err ) {
							console.log( "something went wrong" );
							console.error( err ); // do error checking
						}
					} );
				}

				function selectedLocationAjax( lat, lng ) {
					var subsite = $( "#subsite" ).val();

					// selectedIDs should be a variable on the template
					var locArray = selectedIDs;

					jQuery.ajax( {
						url: subsite + '/wp-admin/admin-ajax.php',
						type: 'POST',
						data: {
							action: 'get_nearest_selected_locations',
							lat: lat,
							lng: lng,
							loc: locArray
						},

						beforeSend: function() {
							$( '.pp-location-list' ).empty(); // remove any locations							
							$( '.loader-container' ).show(); 	// display the loader
							$( '.location-instruction' ).html( 'Choose your nearby Daycare<span>*</span>' ); // Insert header
						},

						// response contains all the HTML
						success: function( response ) {
							$( '.loader-container' ).hide(); // hide the loader
							$( '.location-instruction' ).show(); // show the header
							$( response ).appendTo( '.pp-location-list' ); // append the locations							
						},

						error: function( err ) {
							console.log( "something went wrong" );
							console.error( err ); // do error checking
						}
					} );
				}



				
				var landing_a_page = document.getElementsByClassName( 'd-landing-a-page-container' );
				var landing_b_page = document.getElementsByClassName( 'd-landing-b-page-container' );

				if( landing_a_page.length > 0 ) {
					var gform = /#gf_.*/;

					// toggle modal if form has an issue
					if( gform.test( window.location.hash ) || window.location.hash === "#error" ) {
						if( $( document ).width() < 960 ) {
							UIkit.accordion( ".mobile-options-container" ).toggle( 1, true );
						}

						else {
							UIkit.modal( "#contact-us" ).toggle(); 
						}
					}

					$( document ).scroll( function() {
						var y = $( this ).scrollTop();

						if( y > 500 ) {
							$( '.mobile-fixed-cta-container' ).fadeIn();
						}
						
						else {
							$( '.mobile-fixed-cta-container' ).fadeOut();
						}
					} );
				}




				function locationWithPhoneAjax( lat, lng ) {
					var subsite = $( "#subsite" ).val();

					jQuery.ajax( {
						url: subsite + '/wp-admin/admin-ajax.php',
						type: 'POST',
						data: {
							action: 'get_nearest_locations_with_phone',
							lat: lat,
							lng: lng,
						},

						beforeSend: function() {
							$( '.pp-location-list' ).empty(); // remove any locations							
							$( '.loader-container' ).show(); 	// display the loader
							$( '.location-instruction' ).html( 'Daycares nearby' ); // Insert header
						},

						// response contains all the HTML
						success: function( response ) {
							$( '.loader-container' ).hide(); // hide the loader
							$( '.location-instruction' ).show(); // show the header
							$( response ).appendTo( '.pp-location-list' ); // append the locations
							
						},

						error: function( err ) {
							console.log( "something went wrong" );
							console.error( err ); // do error checking
						}
					} );
				}

				function canadianLocationAjax( lat, lng ) {
					var subsite = $( "#subsite" ).val();

					jQuery.ajax( {
						url: subsite + '/wp-admin/admin-ajax.php',
						type: 'POST',
						data: {
							action: 'get_nearest_canadian_locations',
							lat: lat,
							lng: lng,
						},

						beforeSend: function() {
							$( '.pp-location-list' ).empty(); // remove any locations							
							$( '.loader-container' ).show(); 	// display the loader
							$( '.location-instruction' ).html( 'Daycares nearby' ); // Insert header
						},

						// response contains all the HTML
						success: function( response ) {
							$( '.loader-container' ).hide(); // hide the loader
							$( '.location-instruction' ).show(); // show the header
							$( response ).appendTo( '.pp-location-list' ); // append the locations
							
						},

						error: function( err ) {
							console.log( "something went wrong" );
							console.error( err ); // do error checking
						}
					} );
				}


				function checkZip(value) {
					return (/(^\d{5}$)|(^\d{5}-\d{4}$)/).test(value);
				}

				function checkPostal(value) {
					var postalCodeRegex = new RegExp(
						/^[A-Z]\d[A-Z][ -]?\d[A-Z]\d$/i
					);

					return postalCodeRegex.test(value);
				}

				var tiktok_page = document.getElementsByClassName( 'd-tiktok-page-container' );
				var landing_e_page = document.getElementsByClassName( 'landing-e-national-template' );
				var advantage_page = document.getElementsByClassName( 'd-advantage-plus-page-container' );
				var namegame_page = document.getElementsByClassName( 'd-namegame-page-container' );
				var tiktok_canada_page = document.getElementsByClassName( 'd-tiktok-canada-page-container' );
				
				if( 
					tiktok_page.length > 0 || namegame_page.length > 0 || advantage_page.length > 0 || landing_e_page.length > 0 
				) {
					console.log( 'landing e page' );
					var subsite = $( "#subsite" ).val();
					var input			= document.getElementById( "zipPostalInput" );
					var update  	= document.getElementById( "updateLocationList" );					
					var searchBox = new google.maps.places.SearchBox( input );
					var lat 			= '';
					var lng 			= '';

					/**
					 * get user location on page load, run ajax function
					 **/
					$.getJSON( "https://api.ipregistry.co/?key=6149vez1a59igr", function ( response ) {
						lat = response.location.latitude;
						lng = response.location.longitude;

						if( tiktok_page.length > 0 || landing_e_page.length > 0 ) {
							locationAjax( lat, lng );
						}

						if( advantage_page.length > 0 ) {
							selectedLocationAjax( lat, lng );
						}

						if( namegame_page.length > 0 ) {
							locationWithPhoneAjax( lat, lng );
						}
					} );

					/**
					 * prevent a form submission when using the search field
					 **/ 
					$( input ).keypress( function( event ) {
						
						// 13 is the return/enter key
						if( event.keyCode === 13 ) { 
							event.preventDefault();
						}
					} );

					$( update ).on( 'click', function() {
						if( checkZip( $( input ).val() ) ) {
							
							/**
							 * take the input, and find what the approx lat lng is to that
							 * location.  Then run the locationAjax function
							 */
							jQuery.ajax( {
								url: subsite + '/wp-admin/admin-ajax.php',
								type: 'POST',
								data: {
									action: 'get_locations_by_zip',
									zip: $( input ).val(),
								},
		
								beforeSend: function() {
									$( '.pp-location-list' ).empty(); // remove any locations
									$( '.loader-container' ).show(); 	// display the loader
								},
		
								// response contains all the HTML
								success: function( response ) {
									// console.log( response );
									
									var zip_geo = JSON.parse( response );

									lat = zip_geo.lat;
									lng = zip_geo.lng;
				
									if( lat != null && lng != null ) {
										if( tiktok_page.length > 0 || landing_e_page.length > 0 ) {
											locationAjax( lat, lng );
										}

										if( advantage_page.length > 0 ) {
											selectedLocationAjax( lat, lng );
										}
				
				
										if( namegame_page.length > 0 ) {
											locationWithPhoneAjax( lat, lng );
										}
									}

									else {
										var msg = '<small class="error-msg">Could not detect the nearest locations.  Please try again with a different zip code</small>';
										
										$( '.loader-container' ).hide(); // hide the loader
										$( msg ).appendTo( '.pp-location-list' );
									}
								},
		
								error: function( err ) {
									console.log( "something went wrong" );
									console.error( err ); // do error checking
								}
							} );
						}
						
						else {
							var valid_msg = '<small class="error-msg">Please enter a valid zip code.</small>';
							$( '.pp-location-list' ).empty(); // remove any locations
							$( valid_msg ).appendTo( '.pp-location-list' );
						}
					} );

					searchBox.addListener( "places_changed", function() {
						if( checkZip( $( input ).val() ) ) {
							var places = searchBox.getPlaces();
							
							if( places.length === 0 ) { return; }
									
							lat = places[0].geometry.location.lat();
							lng = places[0].geometry.location.lng();

							// console.log( lat );
							// console.log( lng );

							if( tiktok_page.length > 0 || landing_e_page.length > 0 ) {
								locationAjax( lat, lng );
							}

							if( advantage_page.length > 0 ) {
								selectedLocationAjax( lat, lng );
							}
	
							if( namegame_page.length > 0 ) {
								locationWithPhoneAjax( lat, lng );
							}
						}

						else {
							var valid_msg = '<small class="error-msg">Please enter a valid zip code.</small>';
							$( '.pp-location-list' ).empty(); // remove any locations
							$( valid_msg ).appendTo( '.pp-location-list' );
						}
					} );
				}


				// Canadian TikTok page
				if( tiktok_canada_page.length > 0 ) {
					console.log( 'tiktok_canada_page hits' );
					
					var subsite = $( "#subsite" ).val();
					var input			= document.getElementById( "zipPostalInput" );
					var update  	= document.getElementById( "updateLocationList" );					
					var searchBox = new google.maps.places.SearchBox( input );
					var lat 			= '';
					var lng 			= '';

					/**
					 * get user location on page load, run ajax function
					 **/
					$.getJSON( "https://api.ipregistry.co/?key=6149vez1a59igr", function ( response ) {
						lat = response.location.latitude;
						lng = response.location.longitude;

						console.log( lat );
						console.log( lng );
						console.log( 'run  canadianLocationAjax function' );

						canadianLocationAjax( lat, lng );
					} );

					/**
					 * prevent a form submission when using the search field
					 **/ 
					$( input ).keypress( function( event ) {
						
						// 13 is the return/enter key
						if( event.keyCode === 13 ) { 
							event.preventDefault();
						}
					} );

					$( update ).on( 'click', function() {
						if( checkPostal( $( input ).val() ) ) {
							
							/**
							 * take the input, and find what the approx lat lng is to that
							 * location.  Then run the locationAjax function
							 */
							jQuery.ajax( {
								url: subsite + '/wp-admin/admin-ajax.php',
								type: 'POST',
								data: {
									action: 'get_locations_by_postal',
									zip: $( input ).val(),
								},
		
								beforeSend: function() {
									$( '.pp-location-list' ).empty(); // remove any locations
									$( '.loader-container' ).show(); 	// display the loader
								},
		
								// response contains all the HTML
								success: function( response ) {
									// console.log( response );
									
									var zip_geo = JSON.parse( response );

									lat = zip_geo.lat;
									lng = zip_geo.lng;
				
									if( lat != null && lng != null ) {
										canadianLocationAjax( lat, lng );
									}

									else {
										var msg = '<small class="error-msg">Could not detect the nearest locations.  Please try again with a different postal code</small>';
										
										$( '.loader-container' ).hide(); // hide the loader
										$( msg ).appendTo( '.pp-location-list' );
									}
								},
		
								error: function( err ) {
									console.log( "something went wrong" );
									console.error( err ); // do error checking
								}
							} );
						}
						
						else {
							var valid_msg = '<small class="error-msg">Please enter a valid postal code.</small>';
							$( '.pp-location-list' ).empty(); // remove any locations
							$( valid_msg ).appendTo( '.pp-location-list' );
						}
					} );

					searchBox.addListener( "places_changed", function() {
						if( checkPostal( $( input ).val() ) ) {
							var places = searchBox.getPlaces();
							
							if( places.length === 0 ) { return; }
									
							lat = places[0].geometry.location.lat();
							lng = places[0].geometry.location.lng();

							// console.log( lat );
							// console.log( lng );

							canadianLocationAjax( lat, lng );
						}

						else {
							var valid_msg = '<small class="error-msg">Please enter a valid postal code.</small>';
							$( '.pp-location-list' ).empty(); // remove any locations
							$( valid_msg ).appendTo( '.pp-location-list' );
						}
					} );
				}



				// Landing page mobile map accordion
				$( 'a.map-title-container' ).on( 'click', function() {
					if( $( '.map-accordion-container .uk-open' ).length ) {
						$( 'span', this ).text( 'open map' );
					} 

					else {
						$( 'span', this ).text( 'close map' );
					}
 				});

				$( 'a.location-cta-btn' ).on( 'click', function(e) {
					e.preventDefault();

					$( 'html, body' ).animate( {
						scrollTop: $( "#form-top" ).offset().top
					}, 'fast' );

					console.log( $( this ).data( 'value' ) );
					console.log( $( "#form-top .ginput_container_select select" ).val() );

					$( "#form-top .ginput_container_select select" ).val( $( this ).data( 'value' ) );

					
				} );
      },

      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },

    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
